import React from 'react';
import { Container } from 'react-bootstrap';

export default function CollegeProspectShowcase() {
	return (
		<section className="portfolio-section md:py-[100px] py-[50px] bg-white" data-aos="fade-up">
			<Container>
				<div className="row md:mt-5 mt-0 align-items-center">
					<div className="col-lg-6 heading">
						<h6 className="text-theme ">Event</h6>
						<h2 className="mb-4 font-bold headingFont">College Prospect Showcase 2026</h2>
						<p className="text-justify">
							Over 150 college coaches from D1 through D3 will attend the Donovan showcase. This is purely a match play setting to demonstrate
							your abilities and skills. Excellent opportunity to meet coaches from your dream colleges. Our coaching staff is familiar with
							almost all of the coaches. Aside from the Donovan showcase, athletes will attend the U Penn camp, which will be run by 20 college
							coaches from across the United States. Players will have numerous opportunities to get discovered, even recruited, because they will
							spend time with actual college coaches while practicing drills and playing matches.
						</p>

						<a
							className="customBtn customBtn my-3"
							download="College Prospect Showcase 2026 facsheet.docx"
							href="./assets/documents/College Prospect Showcase 2026 facsheet.docx">
							Download
						</a>
						<div className="mt-2">
							<div href="#" target="_blank" rel="noreferrer" className="text-theme normal-case font-semibold ">
								<b className="text-dark ">SHOW CASE VENUE: </b>
								<br />
								Mercer Country Park Tennis Center, NJ (23 – 25 June)
							</div>
						</div>
					</div>
					<div className="col-lg-5">
						<img className="w-100 rounded-lg" src={'./assets/images/tennis_bg_1.jpg'} alt="Players standing on a court" />
					</div>
				</div>
			</Container>
		</section>
	);
}
